export const useStyles = (theme) => ({
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up(700)]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  sectionMobile: {
    display: "none",
    [theme.breakpoints.down(700)]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  root: {
    display: "flex",
    [theme.breakpoints.down(650)]: {
      marginBottom: 50,
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    [theme.breakpoints.up(650)]: {
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
  },
  inputRoot: {
    height: 70,
  },

  labelRoot: {
    fontSize: 18,
    fontWeight: "bold",
    backgroundColor: "#fff",
    paddingRight: 5,
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
  paper: {
    padding: 10,
    textAlign: "center",
    minHeight: "20vh",
  },
});
